import ContractSpecsTable from './ContractSpecsTable';

export default ContractSpecsTable;
